<div *ngIf="showInfoBar" [ngClass]="[cssClassName]" class="d-sm-flex infoBar-default-style">
  <div *ngFor="let c of content">
    <span class="infoBar-default-text-style"> {{ c.text | translate }} </span>
    <ng-container *ngIf="c.actions">
      <span class="action-default-style" (click)="handleActionClick(action.action)" *ngFor="let action of c.actions">{{
        action.text | translate
      }}</span>
    </ng-container>
  </div>
</div>
